export default __webpack_public_path__ + "static/media/4045.be7aef72.png";